import { createSlice } from "@reduxjs/toolkit";

export const PORTRAIT = "portrait";
export const SQUARE = "square";
export const LANDSCAPE = "landscape";

const GPT_IMAGE_1 = {
  name: "gpt-image-1",
  label: "ChatGPT",
  provider: "openai",
};

const NANO_BANANA = {
  name: "gemini-2.5-flash-image-preview",
  label: "Nano Banana",
  provider: "google",
};

export const IMAGE_MODELS = [GPT_IMAGE_1, NANO_BANANA];

const INITIAL_TOKEN_SETTINGS = {
  color: "Green",
  creatureType: "",
  power: "",
  toughness: "",
  ability: "",
  text: "",
  image: null,
  model: NANO_BANANA,
};

const initialState = {
  ratio: SQUARE,
  transparent: false,
  images: [],
  prompt: "",
  mtgTokenSettings: INITIAL_TOKEN_SETTINGS,
  model: NANO_BANANA,
};

const imageStudioSlice = createSlice({
  name: "imageStudioSlice",
  initialState: initialState,
  reducers: {
    reset(state) {
      state.images = [];
      state.prompt = "";
    },
    setModel(state, action) {
      state.model = action.payload;
    },
    updateTokenSettings(state, action) {
      const { field, value } = action.payload;
      state.mtgTokenSettings[field] = value;
    },
    resetTokenSettings(state) {
      state.mtgTokenSettings = INITIAL_TOKEN_SETTINGS;
    },
    edit(state, action) {
      const imageGeneration = action.payload;
      state.images = [
        {
          index: 0,
          ...imageGeneration.image,
        },
      ];
      state.prompt = "";
    },
    editWithPrompt(state, action) {
      const imageGeneration = action.payload;
      state.images = [
        {
          index: 0,
          ...imageGeneration.image,
        },
      ];
      state.prompt = imageGeneration.prompt;
    },
    usePrompt(state, action) {
      const imageGeneration = action.payload;
      state.images = imageGeneration.images.map((image, index) => ({
        index,
        ...image,
      }));
      state.prompt = imageGeneration.prompt;
    },
    retry(state, action) {
      const imageGeneration = action.payload;
      state.ratio = imageGeneration.ratio;
      state.transparent = imageGeneration.transparent;
      state.images = imageGeneration.images;
      state.images = imageGeneration.images.map((image, index) => ({
        ...image,
        index,
      }));
      state.prompt = imageGeneration.prompt;
    },
    setImageRatio(state, action) {
      state.ratio = action.payload;
    },
    setTransparent(state, action) {
      state.transparent = action.payload;
    },
    setPrompt(state, action) {
      state.prompt = action.payload;
    },
    addImage(state, action) {
      state.images = [
        ...state.images,
        {
          ...action.payload,
          index: state.images.length,
        },
      ];
    },
    updateImage(state, action) {
      const { index, data } = action.payload;
      state.images[index] = {
        ...state.images[index],
        ...data,
      };
    },
    removeImage(state, action) {
      const index = action.payload;
      const newImages = state.images.filter((img, idx) => idx !== index);
      state.images = newImages;
    },
  },
});

export const imageStudioActions = imageStudioSlice.actions;

export default imageStudioSlice.reducer;
